import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersTabsComponent } from './filters-tabs.component';
import { SearchCriteriaComponent } from './search-criteria/search-criteria.component';
import { ColumnSetupComponent } from './column-setup/column-setup.component';

import { DropdownSelectModule } from '../dropdown-select';
import { DropdownMultilevelModule } from '../dropdown-multilevel';
import { DualListBoxModule } from '../dual-list-box';
import { InlineEditModule } from '../inline-edit';
import { SelectListModule } from '../select-list';
import { SwitchesModule } from '../switches';

import { MaterialModule } from '../../src/app/material/material.module';
import { DirectivesModule } from '../directives/directives.module';

import { CrudTableModule } from '../ng-crud-table';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DaterangepickerComponent } from '../daterangepicker/daterangepicker.component';
import { DaterangepickerDirective } from '../daterangepicker/daterangepicker.directive';

import { httpInterceptorProviders } from '../http-interceptors';

import { HighlightPipeModule } from '../pipes';

@NgModule({
  declarations: [FiltersTabsComponent, SearchCriteriaComponent, ColumnSetupComponent,
    DaterangepickerComponent,
    DaterangepickerDirective,
  ],
  exports: [FiltersTabsComponent],
  imports: [
    CommonModule,

    DropdownSelectModule,
    DropdownMultilevelModule,
    DualListBoxModule,
    InlineEditModule,
    SelectListModule,
    SwitchesModule,

    MaterialModule,
    DirectivesModule,

    CrudTableModule,

    FormsModule,//Mat form field
    ReactiveFormsModule,//FormControl

    HighlightPipeModule,
  ],
  providers: [httpInterceptorProviders],
  entryComponents: [
    DaterangepickerComponent,
  ]
})
export class FiltersTabsModule { }
